import { useLocationFilterStore } from '@/lib/store';

/** Те же `location_ids`, что для списка уведомлений: пустой выбор = без фильтра (вся лента). */
export function getNotificationLocationIdsForApi(): number[] | undefined {
  const raw = useLocationFilterStore.getState().selectedLocationIds;
  const arr = Array.isArray(raw) ? raw : [];
  if (arr.length === 0) return undefined;
  return [...arr].sort((a, b) => a - b);
}
